import HouseOne from "../images/HouseOne.jpg";
import HouseTwo from "../images/HouseTwo.jpg";
import HouseThree from "../images/HouseThree.jpg";
import HouseFour from "../images/HouseFour.jpg";

export const SliderData = [{
        title: "Luxury Home In Orlando, USA",
        price: "5,800,000",
        path: "/homes",
        label: "View Home",
        image: HouseOne,
        alt: "House",
    },
    {
        title: "Luxury Villa In Otrani, Italy",
        price: "9,150,000",
        path: "/homes",
        label: "View Home",
        image: HouseTwo,
        alt: "House",
    },
    {
        title: "Luxury Villa In Oia, Greece",
        price: "1,850,000",
        path: "/homes",
        label: "View Home",
        image: HouseThree,
        alt: "House",
    },
    {
        title: "Luxury Villa Near Valencia, Spain",
        price: "4,550,000",
        path: "/homes",
        label: "View Home",
        image: HouseFour,
        alt: "House",
    },
];

// export const SliderData2 = [{
//         title: "Luxury Villa In Bali, Indonesia",
//         price: "1,255,136",
//         path: "/homes",
//         label: "View Home",
//         image: "Image-05",
//         alt: "House",
//     },
//     {
//         title: "Luxury Villa In Cannes, France",
//         price: "3,000,000",
//         path: "/homes",
//         label: "View Home",
//         image: "Image-06",
//         alt: "House",
//     },
//     {
//         title: "Luxury Villa In Bora Bora, French Polynesia",
//         price: "15,900,000",
//         path: "/homes",
//         label: "View Home",
//         image: "Image-07",
//         alt: "House",
//     },
//     {
//         title: "Luxury Villa In Florida, USA",
//         price: "10,650,000",
//         path: "/homes",
//         label: "View Home",
//         image: "Image-08",
//         alt: "House",
//     },
// ];